import { useLocalStorage } from '@uidotdev/usehooks';
import { useState, useMemo, useEffect } from 'react';

export const createSpaceScopedFetch = (userScopedFetch, selectedSpace) => {
    const spaceScopedFetch = async (resource, options = {}) => {
        const spaceOptions = {
            ...options,
            headers: {
                ...options.headers,
                'X-Space-ID': selectedSpace
            }
        };
        return userScopedFetch(resource, spaceOptions);
    };
    spaceScopedFetch.ident = selectedSpace;
    return spaceScopedFetch;
}

export const useSpaces = (spaces, userScopedFetch, defaultSpaceUri) => {
    const [currentSpaceUri, setCurrentSpaceUri] = useLocalStorage('currentSpaceUri', null);

    // Set current space from defaultSpaceUri when it becomes available
    useEffect(() => {
        if (defaultSpaceUri && !currentSpaceUri) {
            setCurrentSpaceUri(defaultSpaceUri);
        }
    }, [defaultSpaceUri, currentSpaceUri, setCurrentSpaceUri]);

    // Create space-aware userScopedFetch that includes the X-Space-ID header
    const spaceScopedFetch = useMemo(() => {
        if (!userScopedFetch || !currentSpaceUri) {
            return null;
        }
        return createSpaceScopedFetch(userScopedFetch, currentSpaceUri);
    }, [userScopedFetch, currentSpaceUri]);

    const currentSpace = spaces?.find(s => s.uri === currentSpaceUri);

    return {
        spaces,
        currentSpace,
        setCurrentSpaceUri,
        spaceScopedFetch
    };
};
